//VIEW SELECT
let viewCheck = localStorage.getItem('itemView');

const onloadCheck = function() {
    const contentDisplayContainer = document.querySelector('.content-display-container');
    if (viewCheck == null || undefined) {
        localStorage.setItem('itemView', 'grid');
        document.body.classList.add('grid-view');
    } else if (viewCheck == 'grid') {
        document.body.classList.add('grid-view');
        document.body.classList.remove('list-view');
        if (typeof(contentDisplayContainer) != 'undefined' && contentDisplayContainer != null) {
            document.getElementById("grid-view-toggle").classList.add('selected');
            document.getElementById("list-view-toggle").classList.remove('selected');
        }
    } else if (viewCheck == 'list') {
        document.body.classList.add('list-view');
        document.body.classList.remove('grid-view');
        if (typeof(contentDisplayContainer) != 'undefined' && contentDisplayContainer != null) {
            document.getElementById("list-view-toggle").classList.add('selected');
            document.getElementById("grid-view-toggle").classList.remove('selected');
        }
    }
}

const idCheck = function() {
    let viewBtnId = this.getAttribute('id');

    const contentDisplayContainer = document.querySelector('.content-display-container');
    
    if (viewBtnId === 'grid-view-toggle') {
        localStorage.setItem('itemView', 'grid');
        this.classList.add('selected');
        if (typeof(contentDisplayContainer) != 'undefined' && contentDisplayContainer != null) {
            document.getElementById("list-view-toggle").classList.remove('selected');
        }
        document.body.classList.remove('list-view');
        document.body.classList.add('grid-view');
    } else {
        localStorage.setItem('itemView', 'list');
        this.classList.add('selected');

        if (typeof(contentDisplayContainer) != 'undefined' && contentDisplayContainer != null) {
            document.getElementById("grid-view-toggle").classList.remove('selected');
        }
        document.body.classList.remove('grid-view');
        document.body.classList.add('list-view');
    }
}

const viewToggles = document.querySelectorAll('.view-toggle');
if (typeof(viewToggles) != 'undefined' && viewToggles != null) {
    for (var i = 0; i < viewToggles.length; ++i) {
        viewToggles[i].addEventListener('click', idCheck, false);
    }
}

document.addEventListener('DOMContentLoaded', onloadCheck, false);